import React from "react";

import "./Product_Sidebar.css";
const Product_Sidebar = () => {
  return <div className="product_sidebar"></div>;
};

export default Product_Sidebar;
